<template>
	<header class="fst-header" :class="{ scrolled: isScrolled }">
		<div class="fst-header__inner">
			<!-- LOGO -->
			<div class="fst-header__logo" @click="$router.push('/')">
				<img src="@/assets/images/tmlogo.png" alt="泛思特logo" />
				<span class="fst-header__logo-text">{{ $t('homeTitle') }}</span>
			</div>

			<!-- 导航菜单 -->
			<nav class="fst-header__nav">
				<router-link to="/" class="fst-header__nav-link" active-class="active" exact>{{ $t('home') }}</router-link>
				<router-link to="/about" class="fst-header__nav-link" active-class="active">{{ $t('about') }}</router-link>

				<div class="fst-header__dropdown" @mouseenter="openDropdown = 'services'" @mouseleave="openDropdown = null">
					<span class="fst-header__nav-link fst-header__nav-link--has-arrow" :class="{ active: isActiveGroup('/services') }">
						{{ $t('services') }}
						<span class="fst-header__arrow">&#9660;</span>
					</span>
					<transition name="fade-down">
						<div v-if="openDropdown === 'services'" class="fst-header__dropdown-menu">
							<router-link to="/services/shipping" class="fst-header__dropdown-item" active-class="active" @click.native="openDropdown = null">{{ $t('shipping') }}</router-link>
							<router-link to="/services/refrigerated" class="fst-header__dropdown-item" active-class="active" @click.native="openDropdown = null">{{ $t('refrigerated') }}</router-link>
							<router-link to="/services/operable" class="fst-header__dropdown-item" active-class="active" @click.native="openDropdown = null">{{ $t('operable') }}</router-link>
							<router-link to="/services/consultation" class="fst-header__dropdown-item" active-class="active" @click.native="openDropdown = null">{{ $t('consultation') }}</router-link>
						</div>
					</transition>
				</div>

				<div class="fst-header__dropdown" @mouseenter="openDropdown = 'contact'" @mouseleave="openDropdown = null">
					<span class="fst-header__nav-link fst-header__nav-link--has-arrow" :class="{ active: isActiveGroup('/contact') }">
						{{ $t('contact') }}
						<span class="fst-header__arrow">&#9660;</span>
					</span>
					<transition name="fade-down">
						<div v-if="openDropdown === 'contact'" class="fst-header__dropdown-menu">
							<router-link to="/contact/business" class="fst-header__dropdown-item" active-class="active" @click.native="openDropdown = null">{{ $t('business') }}</router-link>
							<router-link to="/contact/careers" class="fst-header__dropdown-item" active-class="active" @click.native="openDropdown = null">{{ $t('recruitment') }}</router-link>
						</div>
					</transition>
				</div>
			</nav>

			<!-- 右侧操作区 -->
			<div class="fst-header__actions">
				<!-- 语言切换 -->
				<div class="fst-header__lang">
					<span class="fst-header__lang-option" :class="{ active: currentLang === 'zh' }" @click="changeLanguage('zh')">CN</span>
					<span class="fst-header__lang-divider">/</span>
					<span class="fst-header__lang-option" :class="{ active: currentLang === 'en' }" @click="changeLanguage('en')">EN</span>
				</div>
				<!-- 移动菜单按钮 -->
				<button class="fst-header__mobile-toggle" @click="toggleMobileMenu" aria-label="菜单">
					<i :class="isMobileMenuVisible ? 'el-icon-close' : 'el-icon-menu'"></i>
				</button>
			</div>
		</div>

		<!-- 移动菜单 -->
		<transition name="slide-fade">
			<div v-if="isMobileMenuVisible" class="fst-header__mobile-menu">
				<router-link to="/" class="fst-header__mobile-link" active-class="active" @click.native="isMobileMenuVisible = false">{{ $t('home') }}</router-link>
				<router-link to="/about" class="fst-header__mobile-link" active-class="active" @click.native="isMobileMenuVisible = false">{{ $t('about') }}</router-link>
				<router-link to="/services/shipping" class="fst-header__mobile-link" active-class="active" @click.native="isMobileMenuVisible = false">{{ $t('shipping') }}</router-link>
				<router-link to="/services/refrigerated" class="fst-header__mobile-link" active-class="active" @click.native="isMobileMenuVisible = false">{{ $t('refrigerated') }}</router-link>
				<router-link to="/services/operable" class="fst-header__mobile-link" active-class="active" @click.native="isMobileMenuVisible = false">{{ $t('operable') }}</router-link>
				<router-link to="/services/consultation" class="fst-header__mobile-link" active-class="active" @click.native="isMobileMenuVisible = false">{{ $t('consultation') }}</router-link>
				<router-link to="/contact/business" class="fst-header__mobile-link" active-class="active" @click.native="isMobileMenuVisible = false">{{ $t('business') }}</router-link>
				<router-link to="/contact/careers" class="fst-header__mobile-link" active-class="active" @click.native="isMobileMenuVisible = false">{{ $t('recruitment') }}</router-link>
				<div class="fst-header__mobile-lang">
					<span :class="{ active: currentLang === 'zh' }" @click="changeLanguage('zh')">CN</span>
					<span>/</span>
					<span :class="{ active: currentLang === 'en' }" @click="changeLanguage('en')">EN</span>
				</div>
			</div>
		</transition>
	</header>
</template>

<script>
export default {
	name: 'Header',
	data() {
		return {
			isMobileMenuVisible: false,
			currentLang: localStorage.getItem('lang') || 'zh',
			openDropdown: null,
			isScrolled: false
		};
	},
	created() {
		const savedLang = localStorage.getItem('lang') || 'zh';
		this.changeLanguage(savedLang);
		if (typeof window !== 'undefined') {
			window.addEventListener('scroll', this.handleScroll, { passive: true });
		}
	},
	beforeDestroy() {
		if (typeof window !== 'undefined') {
			window.removeEventListener('scroll', this.handleScroll);
		}
		document.body.style.overflow = ''; // 清理
	},
	computed: {
		isActiveGroup() {
			return (prefix) => this.$route.path.startsWith(prefix);
		}
	},
	methods: {
		toggleMobileMenu() {
			this.isMobileMenuVisible = !this.isMobileMenuVisible;
			// 防止背景滚动
			document.body.style.overflow = this.isMobileMenuVisible ? 'hidden' : '';
		},
		handleScroll() {
			this.isScrolled = window.scrollY > 50;
		},
		changeLanguage(lang) {
			this.currentLang = lang;
			localStorage.setItem('lang', lang);
			this.$i18n.locale = lang;
			this.isMobileMenuVisible = false;
			document.body.style.overflow = '';
		},
		handleOutsideClick(event) {
			// 点击外部关闭移动端菜单
			if (this.isMobileMenuVisible && !event.target.closest('.fst-header__mobile-menu') && !event.target.closest('.fst-header__mobile-toggle')) {
				this.isMobileMenuVisible = false;
				document.body.style.overflow = '';
			}
		}
	},
	mounted() {
		document.addEventListener('click', this.handleOutsideClick);
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleOutsideClick);
	}
};
</script>

<style scoped lang="scss">
/* =====================================================================
   FANSTAR HEADER · Shipex 风格 - 深色全宽导航条
   ===================================================================== */

.fst-header {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1000;
	background: transparent;
	border-bottom: none;
	font-family: 'Inter', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
	transition: background 0.3s ease, box-shadow 0.3s ease;

	&.scrolled {
		background: rgba(0, 0, 0, 0.95);
		backdrop-filter: blur(10px);
		box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
	}
}

.fst-header__inner {
	display: flex;
	align-items: center;
	height: clamp(60px, 8vw, 80px);
	max-width: 1400px;
	width: 100%;
	margin: 0 auto;
	padding: 0 clamp(16px, 3vw, 40px);
}

/* Logo */
.fst-header__logo {
	display: flex;
	align-items: center;
	gap: clamp(8px, 1.5vw, 12px);
	cursor: pointer;
	flex-shrink: 0;
	margin-right: clamp(16px, 3vw, 40px);

	img {
		width: clamp(36px, 5vw, 46px);
		height: auto;
		object-fit: contain;
	}
}

.fst-header__logo-text {
	font-size: clamp(14px, 2vw, 18px);
	font-weight: 700;
	color: #fff;
	letter-spacing: clamp(0.5px, 0.1vw, 1px);
	white-space: nowrap;
}

/* 导航菜单 */
.fst-header__nav {
	display: flex;
	align-items: center;
	gap: 0;
	flex: 1;
	justify-content: center;
}

.fst-header__nav-link {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: clamp(6px, 1vw, 8px) clamp(12px, 2vw, 20px);
	font-size: clamp(11px, 1.2vw, 13px);
	font-weight: 600;
	color: rgba(255, 255, 255, 0.75);
	text-transform: uppercase;
	letter-spacing: clamp(0.5px, 0.1vw, 1px);
	transition: color 0.3s ease;
	position: relative;
	white-space: nowrap;
	cursor: pointer;

	&:hover,
	&.active {
		color: #fff;
	}

	&.active::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: clamp(12px, 2vw, 20px);
		right: clamp(12px, 2vw, 20px);
		height: 2px;
		background: #fff;
		border-radius: 1px;
	}
}

.fst-header__arrow {
	font-size: 9px;
	transition: transform 0.25s ease;
	display: inline-block;
	margin-left: 2px;
}

.fst-header__dropdown:hover .fst-header__arrow {
	transform: rotate(180deg);
}

/* 下拉菜单 */
.fst-header__dropdown {
	position: relative;
}

.fst-header__dropdown-menu {
	position: absolute;
	top: calc(100% + 12px);
	left: 50%;
	transform: translateX(-50%) translateY(8px);
	min-width: clamp(160px, 25vw, 200px);
	background: #ffffff;
	border-radius: 6px;
	box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
	padding: 8px 0;
	opacity: 0;
	visibility: hidden;
	transition: all 0.3s ease;
	z-index: 100;
}

.fst-header__dropdown:hover .fst-header__dropdown-menu {
	opacity: 1;
	visibility: visible;
	transform: translateX(-50%) translateY(0);
}

.fst-header__dropdown-item {
	display: block;
	padding: clamp(8px, 1.2vw, 10px) clamp(16px, 2.5vw, 24px);
	font-size: clamp(12px, 1.5vw, 14px);
	color: #444;
	text-decoration: none;
	transition: all 0.2s ease;

	&.active,
	&:hover {
		color: #0052CC;
		background: rgba(0, 82, 204, 0.05);
	}
}

/* 右侧操作区 */
.fst-header__actions {
	display: flex;
	align-items: center;
	gap: clamp(4px, 0.8vw, 6px);
	flex-shrink: 0;
	margin-left: clamp(16px, 3vw, 40px);
}

.fst-header__social-link {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	color: rgba(255, 255, 255, 0.5);
	transition: color 0.3s ease;
	text-decoration: none;

	&:hover {
		color: #fff;
	}
}

/* 分隔线 */
.fst-header__sep {
	width: 1px;
	height: 24px;
	background: rgba(255, 255, 255, 0.15);
	margin: 0 10px;
}

/* 语言切换 */
.fst-header__lang {
	display: flex;
	align-items: center;
	gap: 0;
	margin-right: clamp(8px, 1.5vw, 12px);
	font-size: clamp(11px, 1.3vw, 12px);
	font-weight: 600;
	letter-spacing: clamp(0.3px, 0.05vw, 0.5px);
}

.fst-header__lang-option {
	padding: 4px 8px;
	color: rgba(255, 255, 255, 0.45);
	cursor: pointer;
	transition: color 0.3s ease;
	border-radius: 4px;

	&.active {
		color: #fff;
	}

	&:not(.active):hover {
		color: rgba(255, 255, 255, 0.7);
	}
}

.fst-header__lang-divider {
	color: rgba(255, 255, 255, 0.2);
	font-weight: 300;
	font-size: 10px;
	padding: 0 2px;
}

/* CTA 按钮 - Shipex 风格 */
.fst-header__cta {
	display: inline-flex;
	align-items: center;
	gap: 10px;
	padding: 12px 28px;
	background: #fff;
	color: #0d1b2a;
	font-size: 13px;
	font-weight: 700;
	border-radius: 30px;
	text-decoration: none;
	transition: all 0.3s ease;
	white-space: nowrap;
	letter-spacing: 0.5px;

	&:hover {
		background: #f0f4f8;
		transform: translateY(-1px);
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
	}
}

.fst-header__cta-icon {
	width: 28px;
	height: 28px;
	background: #0052CC;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: transform 0.3s ease;

	svg {
		width: 12px;
		height: 12px;
	}
}

.fst-header__cta:hover .fst-header__cta-icon {
	transform: translateX(2px);
}

/* 移动菜单按钮 */
.fst-header__mobile-toggle {
	display: none;
	background: none;
	border: none;
	font-size: clamp(20px, 3vw, 22px);
	color: rgba(255, 255, 255, 0.8);
	cursor: pointer;
	padding: clamp(6px, 1vw, 8px);
	transition: color 0.3s ease;

	&:hover {
		color: #fff;
	}
}

/* 移动菜单 */
.fst-header__mobile-menu {
	background: #ffffff;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
	border-top: 1px solid #eee;
	padding: 8px 0;
	display: flex;
	flex-direction: column;
}

.fst-header__mobile-link {
	display: block;
	padding: 14px 24px;
	font-size: 15px;
	color: #333;
	text-decoration: none;
	transition: all 0.2s ease;

	&:hover, &.router-link-active, &.active {
		color: #0052CC;
		background: rgba(0, 82, 204, 0.06);
	}
}

.fst-header__mobile-lang {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 12px 24px;
	border-top: 1px solid #eee;
	font-size: 13px;
	font-weight: 600;

	span {
		cursor: pointer;
		color: #999;
		transition: color 0.2s ease;

		&.active {
			color: #0052CC;
		}
	}
}

/* 动画 */
.fade-down-enter-active,
.fade-down-leave-active {
	transition: all 0.25s ease;
}

.fade-down-enter,
.fade-down-leave-to {
	opacity: 0;
	transform: translateY(-8px);
}

.slide-fade-enter-active,
.slide-fade-leave-active {
	transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
	opacity: 0;
	transform: translateY(-10px);
}

/* ===== 响应式断点系统 ===== */
/* 超大屏 (>1400px) */
@media (min-width: 1401px) {
	.fst-header__inner {
		max-width: 1400px;
	}
}

/* 大屏 (1201px - 1400px) */
@media (max-width: 1400px) {
	.fst-header__inner {
		max-width: 100%;
		padding: 0 clamp(24px, 3vw, 40px);
	}
}

/* 中屏 (1025px - 1200px) */
@media (max-width: 1200px) {
	.fst-header__socials {
		display: none;
	}
	.fst-header__sep {
		display: none;
	}
	.fst-header__nav-link {
		padding: clamp(6px, 1vw, 8px) clamp(10px, 1.5vw, 14px);
		font-size: clamp(11px, 1.1vw, 12px);
	}
}

/* 小屏平板 (769px - 1024px) */
@media (max-width: 1024px) {
	.fst-header__inner {
		padding: 0 clamp(20px, 2.5vw, 24px);
	}
	.fst-header__logo {
		margin-right: clamp(16px, 2.5vw, 24px);
	}
	.fst-header__actions {
		margin-left: clamp(16px, 2.5vw, 24px);
	}
}

/* 大手机/小平板 (481px - 768px) */
@media (max-width: 768px) {
	.fst-header__inner {
		padding: 0 clamp(12px, 2vw, 16px);
	}

	.fst-header__logo {
		margin-right: clamp(8px, 1.5vw, 12px);
	}

	.fst-header__nav { display: none; }
	.fst-header__lang { display: none; }
	.fst-header__cta { display: none; }
	.fst-header__socials { display: none; }
	.fst-header__sep { display: none; }
	.fst-header__mobile-toggle { display: block; }

	/* 移动端操作区推到右侧 */
	.fst-header__actions {
		margin-left: auto;
		margin-right: 20px;
	}

	/* 移动端菜单优化 */
	.fst-header__mobile-menu {
		position: fixed;
		top: clamp(60px, 8vw, 80px);
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(255, 255, 255, 0.98);
		backdrop-filter: blur(10px);
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
		padding: clamp(16px, 3vw, 24px) 0;
		z-index: 999;
	}

	.fst-header__mobile-link {
		padding: clamp(12px, 2vw, 14px) clamp(16px, 3vw, 24px);
		font-size: clamp(14px, 2.5vw, 15px);
		border-bottom: 1px solid rgba(0, 0, 0, 0.05);

		&:last-child {
			border-bottom: none;
		}
	}

	.fst-header__mobile-lang {
		padding: clamp(12px, 2vw, 16px) clamp(16px, 3vw, 24px);
		font-size: clamp(12px, 2vw, 13px);
		border-top: 2px solid rgba(0, 0, 0, 0.08);
		margin-top: clamp(8px, 1.5vw, 12px);
	}
}

/* 小手机 (376px - 480px) */
@media (max-width: 480px) {
	.fst-header__inner {
		padding: 0 12px;
	}
	.fst-header__logo-text {
		display: none; /* 超小屏幕隐藏文字，仅保留logo */
	}
}

/* 超小手机 (<376px) */
@media (max-width: 375px) {
	.fst-header__inner {
		padding: 0 8px;
	}
	.fst-header__logo img {
		width: 32px;
	}
}
</style>
